import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowBack, Article, Campaign, AccessTime, Visibility } from '@mui/icons-material';
import newsService from '../utils/newsService';
import Loader from '../components/Loader';
import { snackbar } from '../utils/showMessage';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const News = () => {
    const navigate = useNavigate();
    const [news, setNews] = useState([]);
    const [pinnedNews, setPinnedNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all'); // all, news, announcement

    useEffect(() => {
        loadNews();
        loadPinnedNews();
    }, [filter]);

    const loadNews = async () => {
        try {
            setLoading(true);
            const type = filter === 'all' ? null : filter;
            const data = await newsService.getAll(type);
            setNews(data);
        } catch (error) {
            console.error('Error loading news:', error);
            snackbar('خطا در بارگذاری اخبار');
        } finally {
            setLoading(false);
        }
    };

    const loadPinnedNews = async () => {
        try {
            const data = await newsService.getPinned();
            setPinnedNews(data);
        } catch (error) {
            console.error('Error loading pinned news:', error);
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('fa-IR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    const NewsCard = ({ item, isPinned = false }) => (
        <Link
            to={`/newsdetail/${item._id}`}
            className="card mb-3 text-decoration-none"
            style={{ borderRight: isPinned ? '4px solid #f59e0b' : 'none' }}
        >
            <div className="card-body">
                <div className="row">
                    {item.image && (
                        <div className="col-4 col-md-3">
                            <img
                                src={`${BASE_URL}/uploads/documents/${item.image}`}
                                alt={item.title}
                                className="w-100 rounded-15"
                                style={{ height: '100px', objectFit: 'cover' }}
                            />
                        </div>
                    )}
                    <div className={item.image ? 'col-8 col-md-9' : 'col-12'}>

                        <div className="d-flex align-items-center mb-2">
                            {item.type === 'announcement' ? (
                                <Campaign fontSize="small" className="text-warning me-1" />
                            ) : (
                                <Article fontSize="small" className="text-primary me-1" />
                            )}
                            <span className="badge bg-light text-dark">
                                {item.type === 'announcement' ? 'اطلاعیه' : 'خبر'}
                            </span>
                            {isPinned && (
                                <span className="badge bg-warning text-dark ms-2">
                                    ثابت شده
                                </span>
                            )}
                        </div>
                        <h6 className="mb-2">{item.title}</h6>
                        {item.summary && (
                            <p className="text-muted mb-2 text-justify" style={{ fontSize: '0.9rem' }}>
                                {item.summary.length > 100
                                    ? item.summary.substring(0, 100) + '...'
                                    : item.summary}
                            </p>
                        )}
                        <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">
                                <AccessTime fontSize="small" className="me-1" style={{ fontSize: '1rem' }} />
                                {formatDate(item.publishDate || item.createdAt)}
                            </small>
                            <small className="text-muted">
                                <Visibility fontSize="small" className="me-1" style={{ fontSize: '1rem' }} />
                                {item.viewCount || 0} بازدید
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="main-container container" >
            {/* Header */}


            {/* Filter Tabs */}
            {/* <div className="row mb-3">
                <div className="col-12">
                    <div className="btn-group w-100" role="group">
                        <button
                            type="button"
                            className={`btn ${filter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setFilter('all')}
                        >
                            همه
                        </button>
                        <button
                            type="button"
                            className={`btn ${filter === 'news' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setFilter('news')}
                        >
                            اخبار
                        </button>
                        <button
                            type="button"
                            className={`btn ${filter === 'announcement' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setFilter('announcement')}
                        >
                            اطلاعیه‌ها
                        </button>
                    </div>
                </div>
            </div> */}

            {/* Pinned News */}
            {pinnedNews.length > 0 && filter === 'all' && (
                <div className="row mb-3">
                    <div className="col-12">
                        <h6 className="mb-2">اخبار مهم</h6>
                        {pinnedNews.map((item) => (
                            <NewsCard key={item._id} item={item} isPinned={true} />
                        ))}
                    </div>
                </div>
            )}

            {/* News List */}
            <div className="row">
                <div className="col-12">
                    {news.length === 0 ? (
                        <div className="card">
                            <div className="card-body text-center py-5">
                                <p className="text-muted mb-0">
                                    {filter === 'news'
                                        ? 'هیچ خبری موجود نیست'
                                        : filter === 'announcement'
                                            ? 'هیچ اطلاعیه‌ای موجود نیست'
                                            : 'هیچ محتوایی موجود نیست'}
                                </p>
                            </div>
                        </div>
                    ) : (
                        news.map((item) => (
                            !item.isPinned && <NewsCard key={item._id} item={item} />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default News;
